// WHAT CAN BE CHANGED?
// Put the desired images into the images-array under data(). All these images will be added to the banner
// For the best effect, all images must be the same size and must be oriented horizontally
// If you want to scrape images from an existing website, you have to edit scrapeBannerImages() and leave the images-array empty

<template>
    <div id="banner">
        <img src="@/assets/banner/icon-wait.svg" id="banner__wait-icon"/>
        <img v-for="image in images" :key="image.imageSrc" :src="require(`@/assets/banner/${image.imageSrc}`)" class="banner__image fade" />
    </div>
</template>

<script>
let slideIndex = 0;
let scrapedImages = [];
import $ from "jquery";

export default {
    name: "BannerSlider",
    mounted() {
        if(!this.images.length) {
          this.scrapeBannerImages();
        } else {
          this.showSlides();
        }
    },
    methods: {
        showSlides() {
            let i;
            let slides = document.getElementsByClassName("banner__image");
            for (i = 0; i < slides.length; i++) {
                slides[i].style.display = "none";  
            }
            slideIndex++;
            if (slideIndex > slides.length) {slideIndex = 1}    
            slides[slideIndex-1].style.display = "block";  
            setTimeout(this.showSlides, 10000); // Change image every 10 seconds
            document.getElementById("banner__wait-icon").style.display = "none";
        },
        scrapeBannerImages() {
            $.get("https://rtvparkstad.nl/")
              .then((res) => {
                let scrapedImage = $("<div/>").html(res).find("img");
                scrapedImage.each(function (i, img) {
                if ($(img).attr("data-src") != undefined) {
                  scrapedImages.push($(img).attr("data-src"));
                }
              });
            }).then(() => {
              this.populateBanner();
              this.showSlides()
            })
        },
        populateBanner() {
          for (let i = 0; i < scrapedImages.length; i++) {
            $("#banner").append("<img class='banner__image fade' src='" + scrapedImages[i] + "'></img>");
          }
        }
    },
    data() {
        return {
            images: [
                // {imageSrc: "banner-0.png"},
                // {imageSrc: "banner-1.png"},
                // {imageSrc: "banner-2.png"},
                // {imageSrc: "banner-3.png"}
            ]
        }
    }
};
</script>

<style lang="scss">
#banner {
  max-width: 768px;
  margin: 0px 0px 20px;
  min-height: 80px;

  #banner__wait-icon {
    height: 50px;
    width: 50px;
    position: absolute;
    left: calc(50% - 25px);
    margin-top: 30px;
  }

  .banner__image {
    width: 100%;
    max-width: 768px;
  }
}

/* Fading animation */
.fade {
  -webkit-animation-name: fade;
  -webkit-animation-duration: 1.5s;
  animation-name: fade;
  animation-duration: 1.5s;
}

@-webkit-keyframes fade {
  from {opacity: .4} 
  to {opacity: 1}
}

@keyframes fade {
  from {opacity: .4} 
  to {opacity: 1}
}

/* Smartphones (portrait and landscape) ----------- */

@media only screen and (min-device-width: 320px) and (max-device-width: 599px) {
  #banner {
    margin: -16px -16px 20px;
  }
}

/* Tablet (portrait) ----------- */

@media only screen and (min-device-width: 600px) and (max-device-width: 899px) {
  #banner {
    margin: -16px 0px 32px;
  }
}

/* Tablet (landscape) ----------- */

@media only screen and (min-device-width: 900px) and (max-device-width: 1199px) {
  #banner {
    margin: -16px 0px 32px;
  }
}

// Desktop versions start here ------------------------------------------------------------------------------------------
/* Desktop ----------- */

@media only screen and (min-device-width: 1200px) and (max-device-width: 1799px) {
  #banner {
    margin: 0px 0px 32px;
  }
}

/* Large desktop ----------- */

@media only screen and (min-device-width: 1800px) {
  #banner {
    margin: 0px 0px 32px;
  }
}
</style>